import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, useTheme, Box } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
// import LastPageIcon from '@mui/icons-material/LastPage';

// const useStyles1 = makeStyles((theme) => ({
//   root: {
//     flexShrink: 0,
//     marginLeft: '20px',
//   },
// }));

const TablePaginationActions = (props) => {
  // const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange, setOffset, offset, estimatedResults, setPage, setBanner, isPremium, isLoading } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    if (!isPremium) {
      setBanner(true)
      return;
    }
    if (page >= Math.ceil(count / rowsPerPage) - 1 && estimatedResults > 100 && isPremium) {
      // setOffset(offset + 100)
      setOffset(offset + rowsPerPage)
      setPage(page + 1)
    } else {
      onPageChange(event, page + 1);
    }
  };

  const handleLastPageButtonClick = (event) => {
    if (page >= Math.ceil(count / rowsPerPage) - 1) {
      setOffset(offset + 100)
    } else {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    }
  };

  return (
    <Box className={`table-pagination`} sx={{ flexShrink: 0, marginLeft: '20px' }}>
      {/* <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton> */}
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0 || isLoading}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        // disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        disabled={page >= Math.ceil(estimatedResults / rowsPerPage) - 1 || isLoading}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      {/* <IconButton
        onClick={handleLastPageButtonClick}
        // disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        // disabled={estimatedResults <= 100}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton> */}
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default TablePaginationActions;
